import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_EP_SUPPORT } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDepGisfoSupportState extends EntityState<IID_EP_SUPPORT, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_EP_GISFO_SUPPORT })
@InterfaceDataStore(InterfaceName.SUPPORT)
export class IIDepGisfoSupportStore extends EntityStore<IIDepGisfoSupportState> {
  constructor() {
    super([]);
  }
}
